
document.addEventListener('change', async function (event) {
  const checkbox = event.target;

  if (checkbox.id !== 'original-wig-box-option') return;

  const shouldAdd = checkbox.checked;
  const variantId = Number(checkbox.dataset.variantId);

  if (!variantId) {
    checkbox.checked = false;
    alert('Wig box product could not be found.');
    return;
  }

  checkbox.disabled = true;

  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    const boxItem = cart.items.find(item => item.variant_id === variantId);

    const url = shouldAdd ? '/cart/add.js' : '/cart/change.js';
    const body = shouldAdd
      ? { id: variantId, quantity: 1 }
      : { id: boxItem?.key, quantity: 0 };

    if (!shouldAdd && !boxItem) {
      checkbox.checked = false;
      checkbox.disabled = false;
      return;
    }

    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });

    if (!response.ok) throw new Error('Cart update failed');

    window.location.reload();
  } catch (error) {
    checkbox.checked = !shouldAdd;
    checkbox.disabled = false;
    alert('Could not update the cart. Please try again.');
  }
});
